module.exports = __webpack_public_path__ + "31152dbe9a2837b64296fc54362aa1ef.MP3";